import { render, staticRenderFns } from "./UpdateCourse.vue?vue&type=template&id=5cd15e44&scoped=true&"
import script from "./UpdateCourse.vue?vue&type=script&lang=js&"
export * from "./UpdateCourse.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCourse.vue?vue&type=style&index=0&id=5cd15e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd15e44",
  null
  
)

/* custom blocks */
import block0 from "./UpdateCourse.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports